const queued: string[] = Array(50);

export default function preloadImages(imageUrls: string[]) {
    for (let imageUrl of imageUrls) {
        if (queued.includes(imageUrl))
            continue;

        const image = new Image();
        image.src = imageUrl;

        queued.shift();
        queued.push(imageUrl);
    }
}